import { NgModule, LOCALE_ID } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import {
    // WebAppSharedLibsModule,
    JhiLanguageHelper,
    FindLanguageFromKeyPipe,
} from './';

@NgModule({
    imports: [
        // WebAppSharedLibsModule,
        FormsModule,
        HttpModule,
        CommonModule,
        NgbModule,
    ],
    declarations: [
        FindLanguageFromKeyPipe,
    ],
    providers: [
        JhiLanguageHelper,
        Title,
        {
            provide: LOCALE_ID,
            useValue: 'en'
        },
    ],
    exports: [
        // WebAppSharedLibsModule,
        FindLanguageFromKeyPipe,
        FormsModule,
        HttpModule,
        CommonModule,
        NgbModule,
    ]
})
export class WebAppSharedCommonModule {}
